import { render } from "./MainSection.vue?vue&type=template&id=25616016&scoped=true"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"

import "./MainSection.vue?vue&type=style&index=0&id=25616016&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25616016"]])

export default __exports__